module.exports = __webpack_public_path__ + "img/content-1.bc13d7ab.png";